export const TickIcon = ({
  className,
  bgColor = "white",
  tickColor = "black",
}) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="10.5" cy="10" r="10" fill={bgColor} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9442 6.01034C17.4628 6.529 17.4628 7.36992 16.9442 7.88859L9.41813 15.4146C8.89947 15.9333 8.05854 15.9333 7.53988 15.4146L3.5555 11.4303C3.03684 10.9116 3.03684 10.0707 3.5555 9.552C4.07417 9.03334 4.91509 9.03334 5.43376 9.552L8.479 12.5973L15.0659 6.01034C15.5846 5.49167 16.4255 5.49167 16.9442 6.01034Z"
        fill={tickColor}
      />
    </svg>
  );
};
